import styled, { css, keyframes } from 'styled-components'

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`

export const ErrorMsgs = styled.span`
  width: 100%;
  display: block;
  margin: 0 10px;
  margin-top: 5px;
  color: #D81212;
`

export const FormStripe = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  animation: ${fadeIn} 0.3s ease;
`

export const FormRow = styled.div`
  margin-bottom: 8px;
`

export const CardLogos = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;
  padding: 16px 0;
  margin-bottom: 20px;
  border-bottom: 1px solid #E9ECEF;

  img {
    height: 32px;
    width: auto;
    object-fit: contain;
    transition: transform 0.2s ease;

    &:hover {
      transform: scale(1.05);
    }
  }
`

export const CustomCardForm = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  background: linear-gradient(135deg, #FFFFFF, #F8F9FA);
  border-radius: 16px;
  padding: 24px;
  border: 1px solid #E9ECEF;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.06);

  .input-group {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .input-label {
    font-size: 13px;
    font-weight: 600;
    color: #495057;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .left {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
  }

  .right {
    display: flex;
    gap: 12px;
    width: 100%;

    @media (max-width: 480px) {
      flex-wrap: wrap;
    }
  }

  input {
    width: 100%;
    height: 48px;
    padding: 0 16px;
    border: 2px solid #E9ECEF;
    border-radius: 10px;
    font-size: 16px;
    color: #1A1A2E;
    background: #FFFFFF;
    transition: all 0.2s ease;
    outline: none;
    box-sizing: border-box;

    &:focus {
      border-color: #4CAF50;
      box-shadow: 0 0 0 4px rgba(76, 175, 80, 0.1);
    }

    &:hover:not(:focus) {
      border-color: #CED4DA;
    }

    &::placeholder {
      color: #ADB5BD;
    }
  }

  .card-number-input {
    letter-spacing: 2px;
    font-family: 'SF Mono', 'Monaco', 'Inconsolata', 'Roboto Mono', monospace;
  }

  .expiry-input {
    flex: 1;
    min-width: 80px;
    text-align: center;
  }

  .cvv-input {
    flex: 1;
    min-width: 80px;
    text-align: center;
    letter-spacing: 2px;
  }

  .card-icon-wrapper {
    position: absolute;
    right: 16px;
    top: 50%;
    transform: translateY(-50%);
    display: flex;
    align-items: center;
    gap: 8px;

    img {
      height: 24px;
      width: auto;
      opacity: 0.5;
      transition: opacity 0.2s ease;
    }

    ${props => props.theme?.rtl && css`
      right: auto;
      left: 16px;
    `}
  }

  .input-with-icon {
    position: relative;

    input {
      padding-right: 100px;

      ${props => props.theme?.rtl && css`
        padding-right: 16px;
        padding-left: 100px;
      `}
    }
  }

  .secure-notice {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: linear-gradient(135deg, rgba(76, 175, 80, 0.08), rgba(76, 175, 80, 0.04));
    border-radius: 10px;
    margin-top: 8px;

    svg {
      color: #4CAF50;
      font-size: 18px;
      flex-shrink: 0;
    }

    span {
      font-size: 13px;
      color: #495057;
      line-height: 1.4;
    }
  }
`

export const SaveCardCheckbox = styled.div`
  margin-top: 16px;
  margin-bottom: 8px;

  label {
    display: flex;
    align-items: center;
    cursor: pointer;
    position: relative;
    padding-left: 35px;
    user-select: none;
    font-size: 14px;
    color: #495057;
    transition: all 0.2s ease;

    &:hover {
      color: #1A1A2E;

      .checkmark {
        border-color: #4CAF50;
        background: rgba(76, 175, 80, 0.05);
      }
    }

    input {
      position: absolute;
      opacity: 0;
      cursor: pointer;
      height: 0;
      width: 0;

      &:checked ~ .checkmark {
        background: linear-gradient(135deg, #4CAF50, #45A049);
        border-color: #4CAF50;

        &:after {
          display: block;
        }
      }
    }

    .checkmark {
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
      height: 22px;
      width: 22px;
      background: #FFFFFF;
      border: 2px solid #E9ECEF;
      border-radius: 6px;
      transition: all 0.2s ease;

      &:after {
        content: '';
        position: absolute;
        display: none;
        left: 7px;
        top: 3px;
        width: 5px;
        height: 10px;
        border: solid white;
        border-width: 0 2px 2px 0;
        transform: rotate(45deg);
      }
    }

    .label-text {
      font-weight: 500;
      line-height: 1.4;
    }
  }
`

export const ErrorMessage = styled.div`
  font-size: 14px;
  font-weight: 500;
  padding: 12px 16px;
  color: #D81212;
  background: linear-gradient(135deg, rgba(216, 18, 18, 0.08), rgba(216, 18, 18, 0.04));
  border-radius: 10px;
  border-left: 4px solid #D81212;
  margin-top: 16px;
  animation: ${fadeIn} 0.3s ease;

  ${props => props.theme?.rtl && css`
    border-left: none;
    border-right: 4px solid #D81212;
  `}
`

export const FormActions = styled.div`
  width: 100%;
  display: flex;
  gap: 12px;
  margin-top: 24px;

  button {
    flex: 1;
    height: 48px;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    transition: all 0.2s ease;
    border: none;
    cursor: pointer;

    &:first-child {
      background: #F1F3F4;
      color: #495057;

      &:hover {
        background: #E9ECEF;
      }
    }

    &:last-child {
      background: linear-gradient(135deg, #4CAF50, #45A049);
      color: #FFFFFF;
      box-shadow: 0 4px 12px rgba(76, 175, 80, 0.25);

      &:hover {
        background: linear-gradient(135deg, #45A049, #3D8B40);
        transform: translateY(-1px);
        box-shadow: 0 6px 16px rgba(76, 175, 80, 0.3);
      }
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
      transform: none;
    }
  }
`
